import React from 'react';
import { format } from 'date-fns';
import { useState, useContext, useEffect } from 'react';
import FileSaver from 'file-saver';
import { useProPhotosReportAreaBookingMutation, useProPhotosReportDigitalMutation, useProPhotosReportMutation } from "../../generated/graphql";
import { ToolbarContext } from "../../contexts/toolbar-context";
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, FormControlLabel, Switch } from "@mui/material";
import { IsoDatePicker } from "../../components/IsoDatePicker";
import { useSnackbar } from "notistack";
import { useDaybookContext } from '../../contexts/Daybook/DayBookContext';

const ProPhotosReport = () => {
    const [dateFromValue, setDateFromValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [dateToValue, setDateToValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [isWait, setWait] = useState(false);
    const [isDigital, setIsDigital] = useState(false);
    const [mutation] = useProPhotosReportMutation({ fetchPolicy: 'no-cache' });
    const [mutationDigital] = useProPhotosReportDigitalMutation({ fetchPolicy: 'no-cache' });
    const [mutationAreaBooking] = useProPhotosReportAreaBookingMutation({ fetchPolicy: 'no-cache' });
    const toolbarContext = useContext(ToolbarContext);
    const nightbook = useDaybookContext();
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        toolbarContext.setPrimary(
            {
                primary: [],
                title: 'Pro Photos Report'
            });
    }, []);

    function handleToggleChange() {
        setIsDigital(prev => !prev);
    }

    function setDateFrom(evt) {
        setDateFromValue(evt.target.value);
    }
    function setDateTo(evt) {
        setDateToValue(evt.target.value);
    }
    async function submitFormAreaBooking() {
        if (isWait) return;
        if (!dateFromValue || !dateToValue) return;
        enqueueSnackbar("Generating report", { color: 'primary' });
        setWait(true);
        try {
            const data = await mutationAreaBooking({ variables: { dateFrom: dateFromValue, dateTo: dateToValue } });
            setWait(false);
            console.log("data pro photos report area booking", data)
            enqueueSnackbar('Rendering file', { color: 'success' });
            const res = await fetch(data?.data?.proPhotosReportAreaBooking?.reportData);
            const blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            FileSaver.saveAs(blobContent, 'pro-photos-report-' + dateFromValue + '__' + dateToValue + '.xlsx');
            //window.open(blobUrl);
        } catch (e) {
            console.log('error', e);
            enqueueSnackbar('Download failed', { color: 'error' });
            setWait(false);
        }
    }
    async function submitForm(type = '') {
        if (isWait) return;
        if (!dateFromValue || !dateToValue) return;
        enqueueSnackbar("Generating report", { color: 'primary' });
        setWait(true);
        try {
            const data = type === 'digital'
                ? await mutationDigital({ variables: { dateFrom: dateFromValue } })
                : await mutation({ variables: { dateFrom: dateFromValue } });
            setWait(false);
            enqueueSnackbar('Rendering file', { color: 'success' });
            const res = await fetch(data?.data?.[type === 'digital' ? 'proPhotosReportDigital' : 'proPhotosReport']?.reportData);
            const blobContent = await res.blob();
            FileSaver.saveAs(blobContent, `pro-photos-report-${dateFromValue}__${dateToValue}.xlsx`);
        } catch (e) {
            console.log('error', e);
            enqueueSnackbar('Download failed', { color: 'error' });
            setWait(false);
        }
    }
    return (
        <div>
            <div>
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Pro Photos Report</AccordionSummary>
                    {nightbook?.useAreaBookingToggle ? (
                        <>
                            <AccordionDetails>
                                <form method="POST" target="_blank">
                                    <div className="grid12">
                                        <IsoDatePicker className="grid12-3" name="dateFrom" value={dateFromValue} onChange={setDateFrom} label="Date Up From" />
                                        <IsoDatePicker className="grid12-3" name="dateTo" value={dateToValue} onChange={setDateTo} label="Date Up to" />
                                    </div>
                                </form>
                            </AccordionDetails>
                            <AccordionActions>
                                <Button variant="contained" onClick={submitFormAreaBooking}>Generate Report</Button>
                            </AccordionActions>
                        </>
                    ) : (
                        <>
                            <AccordionDetails>
                                <form method="POST" target="_blank">
                                    <div className="grid12">
                                        <IsoDatePicker className="grid12-6" name="dateFrom" mondayOnly={true} value={dateFromValue} onChange={setDateFrom} label="Week Commencement Date" />
                                    </div>
                                </form>
                            </AccordionDetails>
                            <AccordionActions>
                                <FormControlLabel
                                    control={<Switch checked={isDigital} onChange={handleToggleChange} />}
                                    label={isDigital ? "Digital Report" : "Standard Report"}
                                />

                                <Button variant="contained" onClick={() => submitForm(isDigital ? 'digital' : '')}>
                                    Generate Report
                                </Button>
                            </AccordionActions>
                        </>
                    )}
                </Accordion>
            </div>
        </div>
    );
      
}

export default ProPhotosReport;
